import { decimalCalc } from "../../../../../../../../server/lib/ad-copy/aggregate/common";

export const calcDiffPercent = (initValue: number, targetValue: number) => {
	return decimalCalc((targetValue / initValue) * 100 - 100, 10);
};
